// extracted by css-extract-rspack-plugin
export default {"SettingLabel":"NJNoc","SettingLabelError":"nStfa","SettingValueWidget":"dJLCZ"};